import { render, staticRenderFns } from "./AlldateEchats.vue?vue&type=template&id=2c8eeafe&scoped=true&"
import script from "./AlldateEchats.vue?vue&type=script&lang=js&"
export * from "./AlldateEchats.vue?vue&type=script&lang=js&"
import style0 from "./AlldateEchats.vue?vue&type=style&index=0&id=2c8eeafe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8eeafe",
  null
  
)

export default component.exports